import actionTypes from '../../action-types'

export default () => ({
  type: actionTypes.AUTHENTICATION.SIGN_OUT,
})
